import fetchOld from '../js/fetchToken'

const fetch = (data, autoGetToken = false) => {
  if (!autoGetToken) {
    return fetchOld(data)
  } else {
    if (!data.data) {
      data.data = {};
    }
    if (!data.params) {
      data.params = {}
    }
    data.params.token = JSON.parse(localStorage.getItem('userInfo')).token;
    data.data.token = JSON.parse(localStorage.getItem('userInfo')).token;
    return fetchOld(data)
  }
}

// 栏目数据
export const getAppColumn = (params = {}) => {
	return fetch({
		url: '/ls/art/uc/column/getAppColumn',
		params
	})
}

// 资讯列表
export const getAppConsult = (params = {}) => {
	return fetch({
		url: '/ls/art/uc/consult/getAppConsult',
		params
	})
}

// 资讯详情
export const getAppConsultDetail = (params = {}) => {
	return fetch({
		url: '/ls/art/uc/consult/getAppConsultDetail',
		params
	})
}

// post
export const messagePhoneLoginWeb = (data) => {
	return fetch({
		method: 'POST',
		url: '/ls/flash/uc/login/messagePhoneLoginWeb',
		data: data
	})
}